import * as ActionTypes from '../actions/types/DashboardActionTypes';
import * as RegistryOverviewActionTypes from '../actions/types/RegistryOverviewActionTypes';

const initialState = {
  busy: true,
  wedding_website_feature: {},
  registry_feature: {},
  checklist_feature: {},
  guestlist_feature: {},
  days_til_wedding: -1,
  products: [],
  productsLoading: false,
  registryChecklist: {},
  registryChecklistLoading: false,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_DASHBOARD: {
      return Object.assign({}, state, { busy: true });
    }
    case ActionTypes.RECEIVE_DASHBOARD: {
      return Object.assign(
        {},
        state,
        action.payload,
        { busy: false }
      );
    }
    case RegistryOverviewActionTypes.REQUEST_PRODUCTS: {
      return { ...state, productsLoading: true };
    }
    case RegistryOverviewActionTypes.RECEIVE_PRODUCTS: {
      return { ...state, productsLoading: false, products: action.data };
    }
    case RegistryOverviewActionTypes.REQUEST_ADDITIONAL_PRODUCTS: {
      return { ...state, additionalProductsLoading: true };
    }
    case RegistryOverviewActionTypes.RECEIVE_ADDITIONAL_PRODUCTS: {
      return { ...state, additionalProductsLoading: false, products: action.data };
    }
    case RegistryOverviewActionTypes.RECEIVE_CHECKLIST: {
      return { ...state, registryChecklistLoading: false, registryChecklist: { ...action.payload } };
    }
    case RegistryOverviewActionTypes.REQUEST_CHECKLIST: {
      return { ...state, registryChecklistLoading: true };
    }
    default: return state;
  }
};

export default dashboardReducer;



// WEBPACK FOOTER //
// ./src/reducers/dashboard.js